import { IStandardMultipleAutocomplete } from "../../_common/interface/autocomplete/iStandardMultipleAutocomplete";
import { racingLicenseGradeService } from "../../_services/racingLicenseGrade.service";
import { MultipleAutoComplete } from "./multiple.autocomplete";

interface IMultipleExtAutocomplete extends IStandardMultipleAutocomplete {
}

export const LicenseGradeMultipleAutoComplete = (params: IMultipleExtAutocomplete) => {

    return (
        <MultipleAutoComplete
            {...params}
            itemsLoader={racingLicenseGradeService
                .dropdown}
            label={"Licence Grade"} />
    );
}